import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useDocumentTitle } from '../../fetch/fetchReleaseNotes';

export default function ReleaseNoteDocumentLink({ partNumber, isVideo }) {
    const { title, isLoading } = useDocumentTitle(partNumber);

    if (isLoading) {
        return <span>Loading...</span>;
    }

    const url = !isVideo ? `${window.location.origin}/literature/view/${partNumber}` :
    `${window.location.origin}/literature/video/${partNumber}`;
    return (
        <span>
            <a href={url}>
                {title}
            </a>
            <a href={url} target="_blank">
                <OpenInNewIcon fontSize='inherit' />
            </a>
            &nbsp;
        </span>
    );
}